module.exports = __webpack_public_path__ + "img/cart-list-item-bg.77f45b25.png";